module.exports = __webpack_public_path__ + "img/posdomesticidades.cd3a5bf8.png";